// src/pages/Account/BankForm.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios';
import chartOfAccountsApi from '../../api/chartOfAccountsApi'; // Added

import { Input }    from '../../components/ui/input';
import { Checkbox } from '../../components/ui/checkbox';
import { Button }   from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import SearchableSelect from '../../components/ui/SearchableSelect'; // Added

export default function BankForm() {
  const navigate  = useNavigate();
  const { id }    = useParams();
  const editingId = id ? parseInt(id, 10) : null;

  // خذ companyId و branchId من التوكن/التخزين المحلي
  const companyId = parseInt(localStorage.getItem('companyId'), 10);
  const branchId  = parseInt(localStorage.getItem('branchId'),  10);
  
  const [accounts, setAccounts] = useState([]); // Added

  const [form, setForm] = useState({
    name:        '',
    country:     '',
    city:        '',
    accCode:     '',
    accountId:   null, // Added
    area:        '',
    tel:         '',
    mobile:      '',
    notes:       '',
    disPre:      0,
    changeInPOS: false,
    isDeleted:   false,
    // لا تعرض حقول الشركة والفرع في الواجهة
    companyId,
    branchId
  });

  useEffect(() => {
    // Fetch Accounts
    chartOfAccountsApi.getPostable().then(res => setAccounts(res.data || [])).catch(console.error);

    if (editingId) {
      axios.get(`/Bank/${editingId}`)
        .then(r => {
          const d = r.data;
          setForm(f => ({
            ...f,
            name:        d.name        || '',
            country:     d.country     || '',
            city:        d.city        || '',
            accCode:     d.accCode     || '',
            accountId:   d.accountId   || null, // Added
            area:        d.area        || '',
            tel:         d.tel         || '',
            mobile:      d.mobile      || '',
            notes:       d.notes       || '',
            disPre:      d.disPre      || 0,
            changeInPOS: d.changeInPOS || false,
            isDeleted:   d.isDeleted   || false,
            // تأكد أن الشركة والفرع لا يتغيران
            companyId,
            branchId
          }));
        })
        .catch(console.error);
    }
  }, [editingId, companyId, branchId]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };
  const handleNumberChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: parseFloat(value) }));
  };
  const handleCheckboxChange = e => {
    const { name, checked } = e.target;
    setForm(f => ({ ...f, [name]: checked }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = { ...form }; 
    // payload.companyId و payload.branchId مُضمّنان
    try {
      if (editingId) {
        await axios.put(`/Bank/${editingId}`, payload);
        alert('✅ تم تحديث البنك');
      } else {
        await axios.post(`/Bank`, payload);
        alert('✅ تم إنشاء بنك جديد');
      }
      navigate('/bank');
    } catch (err) {
      console.error(err);
      alert('❌ حدث خطأ أثناء الحفظ');
    }
  };

  return (
    <Card className="max-w-lg mx-auto mt-10" dir="rtl">
      <CardContent>
        <h2 className="text-xl font-bold mb-6">
          {editingId ? 'تعديل بنك' : 'بنك جديد'}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* الاسم */}
          <div>
            <label className="block mb-1">الاسم</label>
            <Input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* الدولة والمدينة */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block mb-1">الدولة</label>
              <Input name="country" value={form.country} onChange={handleChange}/>
            </div>
            <div>
              <label className="block mb-1">المدينة</label>
              <Input name="city"    value={form.city}    onChange={handleChange}/>
            </div>
          </div>

          {/* كود الحساب والمنطقة */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block mb-1">الحساب المرتبط (دليل الحسابات)</label>
              <SearchableSelect
                  options={accounts}
                  value={form.accountId}
                  onChange={(val) => {
                      setForm(f => ({ ...f, accountId: val }));
                      // Auto-fill AccCode if needed
                      const selected = accounts.find(a => a.id === val);
                      if (selected) setForm(f => ({ ...f, accCode: selected.code }));
                  }}
                  getOptionLabel={(option) => `${option.code} - ${option.nameAr}`}
                  getOptionValue={(option) => option.id}
                  placeholder="اختر الحساب..."
              />
            </div>
            <div>
              <label className="block mb-1">كود الحساب (يدوي)</label>
              <Input name="accCode" value={form.accCode} onChange={handleChange}/>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
             <div>
              <label className="block mb-1">المنطقة</label>
              <Input name="area"    value={form.area}    onChange={handleChange}/>
            </div>
          </div>

          {/* هاتف وموبايل */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block mb-1">هاتف</label>
              <Input name="tel"    value={form.tel}    onChange={handleChange}/>
            </div>
            <div>
              <label className="block mb-1">موبايل</label>
              <Input name="mobile" value={form.mobile} onChange={handleChange}/>
            </div>
          </div>

          {/* نسبة الخصم */}
          <div>
            <label className="block mb-1">نسبة الخصم (%)</label>
            <Input
              name="disPre"
              type="number"
              step="0.01"
              value={form.disPre}
              onChange={handleNumberChange}
            />
          </div>

          {/* ملاحظات */}
          <div>
            <label className="block mb-1">ملاحظات</label>
            <Input name="notes" value={form.notes} onChange={handleChange}/>
          </div>

          {/* checkboxes */}
          <div className="flex items-center space-x-6 space-x-reverse">
            <div className="flex items-center gap-2">
              <Checkbox
                id="changeInPOS"
                name="changeInPOS"
                checked={form.changeInPOS}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="changeInPOS">التغيير في POS</label>
            </div>
            <div className="flex items-center gap-2">
              <Checkbox
                id="isDeleted"
                name="isDeleted"
                checked={form.isDeleted}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="isDeleted">محذوف</label>
            </div>
          </div>

          {/* الأزرار */}
          <div className="flex justify-end gap-2 mt-6">
            <Button type="submit">💾 حفظ</Button>
            <Button variant="outline" onClick={() => navigate('/banks')}>
              ↩️ رجوع
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
